import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ef5785b&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3ef5785b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5785b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef5785b')) {
      api.createRecord('3ef5785b', component.options)
    } else {
      api.reload('3ef5785b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ef5785b&scoped=true&lang=pug", function () {
      api.rerender('3ef5785b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/account/index.vue"
export default component.exports